import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { Column } from '@repo/ui/data-table'
import { TableDate } from '@repo/ui/data-table-cells'
import { PeopleTwoIcon, PlusIcon } from '@repo/ui/icons'
import React from 'react'

import { API } from '../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../components/elements/dynamic-table'
import UserNavBar from '../../components/elements/nav-bar'
import { Paths } from '../../lib/constants/path'
import { pcrPayScaleTypeMapping } from '../../lib/types/enums/pcr-pay-scales/pcr-pay-scale-type.enum'
import { PcrPayScale } from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale'

const PcrPayScalesPage = () => {
  const { navigateWithEvent, navigate } = useNavigator()

  const tableRef = React.useRef<DynamicTableRef<PcrPayScale>>(null)

  const columns: Column<PcrPayScale>[] = [
    {
      accessorKey: 'type',
      header: 'Type',
      enableSorting: true,
      cell: (data) => pcrPayScaleTypeMapping[data.row.original.type]
    },
    {
      accessorKey: 'amount',
      header: 'Montant',
      enableSorting: true,
      cell: (data) => `${data.row.original.amount}€`
    },
    {
      accessorKey: 'createdAt',
      header: 'Date effective',
      enableSorting: true,
      cell: (data) => <TableDate date={data.row.original.createdAt} />
    }
  ]

  return (
    <div>
      <UserNavBar title="Barèmes de rémunération" icon={PeopleTwoIcon} />
      <div className="h-4" />
      <Box>
        <DynamicDataTable
          ref={tableRef}
          title={'Liste des barèmes'}
          className="p-0"
          onRowClick={(row, event) =>
            navigateWithEvent(
              Paths.PCR_PAY_SCALE_UPDATE_PAGE.replace(':id', row.id.toString()),
              event
            )
          }
          deleteMessage={{
            name: 'barèmes',
            attributeName: 'type',
            deleteOne: (pcrPayScale) =>
              `Êtes-vous sûr de vouloir supprimer le barème "${pcrPayScaleTypeMapping[pcrPayScale.type]}" ?`
          }}
          columns={columns}
          selectable
          endpoint={API.pcrPayScale.getAll.url}
          allowSearchParam
          actions={[
            {
              type: 'global',
              icon: PlusIcon,
              label: 'Ajouter un barème',
              fn: () => navigate(Paths.PCR_PAY_SCALE_CREATE_PAGE)
            }
          ]}
        />
      </Box>
    </div>
  )
}

export default PcrPayScalesPage
